import { createGrid, forEachColumn, WIDTH, HEIGHT, getIndex, setCell } from '../utils';

export class StacksMode {
  constructor({ up }) {
    this.tick = 0;
    this.waveform = [];

    this.reflectY = false;
    const rnd1 = Math.random();
    if (!up && rnd1 < 0.5) {
      this.reflectY = true;
    }
  }
  update(delta, { audioData } = {}) {
    this.waveform = audioData?.waveform;
  }
  getData() {
    const grid = createGrid();
    if (this.waveform) {
      forEachColumn(({x}) => {
        let index = [27,24,20,16,12, 8, 5, 4, 5, 8,12,16,20,24,27][x];
        const y = HEIGHT - Math.round(this.waveform[index] * HEIGHT);
        for (let yy = HEIGHT; yy > y; yy--) {
          if (this.reflectY) {
            setCell(grid, x, HEIGHT - yy, true, {dropOutside: true});
          } else {
            setCell(grid, x, yy, true, {dropOutside: true});
          }
        }
      });
    }
    return grid;
  }
}